// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ComicsRouteImport } from './routes/comics'
import { Route as AuteurRouteImport } from './routes/auteur'
import { Route as IndexRouteImport } from './routes/index'

const GalleryRoute = GalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ComicsRoute = ComicsRouteImport.update({
            id: '/comics',path: '/comics',getParentRoute: () => rootRouteImport
          })
const AuteurRoute = AuteurRouteImport.update({
            id: '/auteur',path: '/auteur',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuteurRoute: AuteurRoute,ComicsRoute: ComicsRoute,ContactRoute: ContactRoute,GalleryRoute: GalleryRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)